<template>
  <component
    :is="link ? 'a' : 'div'"
    class="avatar"
    :class="[isMini && 'avatar--mini']"
    :href="link || undefined"
  >
    <div class="avatar__wrap">
      <img
        v-if="img"
        class="avatar__img"
        :src="img"
        :alt="alt"
      >
      <v-icon
        v-else
        class="avatar__user"
        type="user"
      />
    </div>
    <span class="avatar__name">
      {{ name }}
      <small
        v-if="meta"
        class="avatar__meta"
      >{{ meta }}</small>
    </span>
  </component>
</template>

<script>
  import Icon from '@/atoms/Icon';
  export default {
    components: {
      "v-icon": Icon,
    },
    props: {
      img: {
        type: String,
        default: null
      },
      link: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      meta: {
        type: String,
        default: null
      },
      alt: {
        type: String,
        default: null
      },
      isMini: {
        type: Boolean,
        default: null
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";
  $avatar-size: 3rem;
  $avatar-size-sm: 1.875rem;
  .avatar {
    display: flex;
    align-items: center;
    &,
    &:hover,
    &:focus {
      text-decoration: none;
    }
    &__wrap {
      display: block;
      height: $avatar-size;
      width: $avatar-size;
      flex-shrink: 0;
      line-height: $avatar-size;
      font-size: $avatar-size/1.5;
      border-radius: 50%;
      border: solid 3px $polo;
      overflow: hidden;
      text-align: center;
      background-color: $zircon;
    }
    &__user {
      color: $polo;
      line-height: inherit;
    }
    &__img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    &__name {
      text-align: left;
      margin-left: .5rem;
      font-size: 1rem;
      line-height: 1.1;
      word-break: break-word;
      hyphens: auto;

    }
    &__meta {
      display: block;
    }
    &--mini &__wrap {
      height: $avatar-size-sm;
      width: $avatar-size-sm;
      line-height: $avatar-size-sm;
      font-size: $avatar-size-sm/1.5;
    }
  }
</style>
